/**
 * CartSummaryV2 — Variant-Aware Cart Summary
 *
 * Drop-in replacement for the inline footer content in SideCart.
 * Routes to the correct variant sub-component based on the `variant` prop.
 *
 * Variant map is extensible: to add a new variant (e.g. 'club-upsell', 'bnpl'),
 * create a component in ./variants/ and add it to VARIANT_MAP.
 */

'use client';

import type { ComponentType } from 'react';
import { DefaultVariant } from './variants/DefaultVariant';
import { FreeShippingBarVariant } from './variants/FreeShippingBarVariant';
import { CreditsBarVariant } from './variants/CreditsBarVariant';
import type { CartSummaryV2Props, CartSummaryVariant, VariantProps } from './types';

const VARIANT_MAP: Record<CartSummaryVariant, ComponentType<VariantProps>> = {
  'default': DefaultVariant,
  'free-shipping-bar': FreeShippingBarVariant,
  'credits-bar': CreditsBarVariant,
};

export function CartSummaryV2({ variant = 'default', ...rest }: Readonly<CartSummaryV2Props>) {
  const VariantComponent = VARIANT_MAP[variant] ?? DefaultVariant;
  return <VariantComponent {...rest} />;
}
